import { Environment, EnvironmentVariables } from '@env/types'

export const environment: EnvironmentVariables = {
    productionMode: true,
    name: Environment.Production,

    api: {
        clientId: '5',
        clientSecret: 'KQVCXL4imTLLgqMW8DfHDF3UqbV4vfACk3srK8AC',
        schema: 'https',
        hostname: 'api.joinprogram.fr',
        acceptVersionRange: '>=3.34.3 <5.0.0',
    },

    pubsub: {
        schema: 'wss',
        hostname: 'v2.pubsub.joinprogram.fr',
    },
}
